import React from "react";
import webDesign from "../Static/img/web_design.svg";
import appDeveloper from "../Static/img/app_developer.svg";
import { Parallax } from "react-parallax";
import { useDocumentMeta } from '../useDocumentMeta';

function AboutMe(props) {
  props.setColorData("#48486a");
  props.setHeaderClassName("");
  window.scrollTo(0, 0);

  const aboutMe = {
    about1Title: "ABOUT ME",
    about1Text: "",
    about2Title: "강점",
    about2Text: "개발 능력과 운영 노하우를 겸비하여, 귀사의 시스템을 가장 든든하게 책임지는 핵심 인재가 되겠습니다.",
  };

  useDocumentMeta("About me", "#48486a");

  return (
    <>
      <div className="whiteBg aboutmes">
        <div className="basicWidth mainSlide ">
          <div className="msTextBox">
            <div className="msTxtBoxPt">
              <h1>{aboutMe.about1Title}</h1>
              <div className="subtxt">
                저는 디자인의 섬세함으로 시작해 다양한 개발을 시작으로 이제는 인프라의 안정성과 AI의 가능성을 탐구하고 있습니다.<br/><br/>
                단순히 '돌아가는 코드'를 짜는 데 만족하지 않습니다. 대용량 데이터를 스트리밍으로 최적화하고, ITGC 감사 대응 시스템을 구축하며 제가 배운 것은 기술의 화려함보다 '무결성과 안정성'의 가치였습니다.  <br/>
                또한 미니 PC에 Proxmox 가상화 환경을 세팅하고 로컬 LLM으로 데이터를 분석하는등 개발을 즐기고 있습니다.<br/><br/>
                현업의 요구사항을 누구보다 빠르게 이해하고, 인프라부터 서비스 로직까지 직접 구현해낼 수 있는 '풀스택 메이커'로서 여러분의 비즈니스에 확실한 해답을 드리겠습니다.
              </div>
            </div>
          </div>
          <div className="msImgBox">
            <div className="msImgBoxPt middle">
              <img src={webDesign} alt="" />
            </div>
          </div>
        </div>

        {/* <div className="basicWidth mainSlide hiddenMenu rightFix">
          <div className="msTextBox">
            <div className="msTxtBoxPt">
              <h1>{aboutMe.about2Title}</h1>
              <div className="subtxt">{aboutMe.about2Text}</div>
            </div>
          </div>
          <div className="msImgBox">
            <div className="msImgBoxPt middle">
              <img src={appDeveloper} alt="" />
            </div>
          </div>
        </div> */}

      </div>
    </>
  );
}
export default AboutMe;
